import { busyWhile } from "lib/@components/busy/busy-while"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useDialog } from "lib/@hooks/useDialog"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { updateAssetRegister } from "routes/asset-register/controller/update-asset-register"
import { useRegisterProcessingGuard } from "./use-register-processing-guard"

export function RegisterMetadataMenuItem({ icon, label, dataCy, DialogComponent, errorMessage, getUpdateValues }) {
    const { register } = useBoundContext()
    const { isBlocked, showBlockedAlert } = useRegisterProcessingGuard()
    const editDialog = useDialog(<DialogComponent source={register} />)

    return <ContextMenuItem icon={icon} label={label} onClick={edit} data-cy={dataCy} />

    async function edit() {
        if (isBlocked) {
            showBlockedAlert()
            return
        }

        const updated = await editDialog()
        if (!updated) return

        try {
            const result = await busyWhile(
                async () => updateAssetRegister({ registerId: register.id, ...getUpdateValues(updated) }),
                "Updating register"
            )

            if (!result) {
                errorSnackbar(errorMessage)
            }
        } catch (e) {
            errorSnackbar(errorMessage)
        }
    }
}
